import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { type TagsRow } from 'entities/Tags/model/TagsRow'
import { useTagsContext } from 'pages/settings/pages/tags/context/tagsContext'
import { getTagsTableActions } from 'pages/settings/pages/tags/ui/TagsListTable/getTagsTableActions'
import { DeleteBulkAction } from 'pages/settings/pages/tags/ui/TagsAction/TagsAction'
import styles from './styles.module.scss'
import { columns } from './columns'

export const TagsListTable = observer(() => {
  const tagsStore = useTagsContext()
  const {
    tableStore,
    initialLoading,
    changePaging,
    items,
    isUserCanManageTags,
    isCheckboxDisabled,
  } = tagsStore

  const getColumns = useMemo(
    () =>
      columns({
        tableStore,
      }),
    [tableStore]
  )

  const rows = useMemo(() => {
    return items.map((item) => {
      item.setActionsProps({
        actions: getTagsTableActions(item, tagsStore, isUserCanManageTags),
      })

      item.setAriaLabel('TagsRow')
      item.setCheckboxDisabled(isCheckboxDisabled)

      return item
    })
  }, [items, isUserCanManageTags, isCheckboxDisabled])

  const onRowClick = (row: TagsRow) => {
    tagsStore.onShowContacts(row.id)
  }

  return (
    <section className={styles.table}>
      <Table
        ariaLabel={'TagsTable'}
        store={tableStore}
        columns={getColumns}
        rows={rows}
        loading={initialLoading}
        virtualization
        onChangePagination={changePaging}
        withCheckbox={isUserCanManageTags}
        onRowClick={onRowClick}
        headerLeftContentProps={{
          actionsContent: <DeleteBulkAction />,
        }}
      />
    </section>
  )
})
